import { type OptionsObject, type SnackbarMessage, useSnackbar } from "notistack";
import { useCallback } from "react";

/**
 * Helper utility to show standard toasts
 */
export function useToast() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  type ToastOptions = Omit<OptionsObject, "message" | "variant">;

  const showSuccessToast = useCallback(
    (message: SnackbarMessage, options?: ToastOptions) => {
      enqueueSnackbar({
        message,
        variant: "success",
        ...options,
      });
    },
    [enqueueSnackbar]
  );

  const showInfoToast = useCallback(
    (message: SnackbarMessage, options?: ToastOptions) => {
      enqueueSnackbar({
        message,
        variant: "info",
        ...options,
      });
    },
    [enqueueSnackbar]
  );

  const showErrorToast = useCallback(
    (message: SnackbarMessage, options?: ToastOptions) => {
      enqueueSnackbar({
        message,
        variant: "error",
        ...options,
      });
    },
    [enqueueSnackbar]
  );

  const showWarningToast = useCallback(
    (message: SnackbarMessage, options?: ToastOptions) => {
      enqueueSnackbar({
        message,
        variant: "warning",
        ...options,
      });
    },
    [enqueueSnackbar]
  );

  return {
    showSuccessToast,
    showInfoToast,
    showErrorToast,
    showWarningToast,
    closeSnackbar,
  };
}
